import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {emailFormat} from 'src/app/components/common/validations';
import {SessionService} from 'src/app/services/session.service';
import * as CryptoJS from 'crypto-js';
import {Constants} from 'src/app/components/common/constants';
import {DialogService} from '../../../../services/dialog.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {PAISES_MUNDO} from '../../../../models/application/countriesWorld';
import {Router} from '@angular/router';

@Component({
    selector: 'app-create-account',
    templateUrl: './create-account.component.html',
    styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent implements OnInit {
    @Input() active: boolean;
    form: FormGroup;
    formSession: FormGroup;
    accountCreated: boolean;
    tipoCuenta = new FormControl(false);
    userData: any;
    isBusiness = false;
    initSession = false;
    existemail = false;
    public hide = true;
    countries: any;
    productsList: any;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;

    constructor(
        private fb: FormBuilder,
        private dialogService: DialogService,
        private sessionService: SessionService,
        private deviceService: DeviceDetectorService,
        private router: Router
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        this.userData = this.sessionService.getPaymentAccount();
        this.refreshSteps();
    }

    ngOnInit(): void {
        this.productsList = this.sessionService.getCartItems();
        if (this.userData && this.userData.user !== '' && this.userData.user !== null) {
            this.addDataLayer();
            this.refreshSteps();
        }
    }

    createAccount(): void {
        this.sessionService.setInitText(true);
        setTimeout(() => {
            if (this.router.url === '/assinatura-digital-gratis') {
                this.sessionService.emitNewSessionText(true);
            } else {
                this.router.navigate(['/assinatura-digital-gratis']);
            }
        }, 200);
    }

    refreshSteps(): void {
        const steps = this.sessionService.getPaymentSteps();
        this.accountCreated = steps.accountStep.completed;
    }

    addDataLayer(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
        // @ts-ignore
        dataLayer.push({
            event: 'checkout',
            ecommerce: {
                checkout: {
                    actionField: {step: 1, option: 'Sesion iniciada'},
                }
            }
        });
    }

}
